/**
 * Parses the `user` JSON string.
 * Returns null when missing, empty, or invalid JSON.
 */
export function parseUserJsonProp<T>(
  userJson: string | null | undefined,
): T | null {
  if (userJson == null || userJson === "") {
    return null;
  }
  try {
    return JSON.parse(userJson) as T;
  } catch {
    return null;
  }
}
